"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BookAConsultation() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="226411" id="get-started" className="relative overflow-hidden border-t border-border py-40 !bg-[rgba(235,255,254,1)]">
      <img src="https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/04/bewei_hands_byLinda.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/bewei_hands_consultation.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1642411/img/bewei_hands_consultation.png-wvc-sizes" alt="Consultation Background" className="absolute inset-0 w-full h-full object-cover opacity-20 pointer-events-none" loading="lazy" decoding="async" />
      
      <div ref={ref} className={`relative z-10 container mx-auto max-w-screen-xl px-4 text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="font-default font-bold leading-tight mb-6 tracking-tighter !text-5xl !text-[rgba(53,155,125,1)]">Bereit für deine Probebehandlung?</h2>
        
        <p className="font-sans text-foreground/80 mb-12 max-w-full mx-auto leading-relaxed !text-2xl !font-extrabold">Nutze jetzt unser Kennenlern-Angebot: 29 Euro statt 49 Euro!</p>
        
        <div className="mt-4 flex justify-center w-full">
          <div className="zeeg-inline-widget w-full max-w-2xl" id="zeeg-embed-bodyconcept-by-linda-bewei-hands" style={{
          minWidth: "320px",
          minHeight: "780px"
        }}></div>
          <script type="text/javascript" src="https://assets.zeeg.me/embed.min.js" data-user="bodyconcept-by-linda" data-event-type="bewei-hands" data-redirect-parent="true" async></script>
        </div>
      </div>
    </section>;
}